import { render, staticRenderFns } from "./IbOption.vue?vue&type=template&id=4c47b363"
import script from "./IbOption.vue?vue&type=script&lang=js"
export * from "./IbOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports